import React from "react";
import All from "./All";
import Closed from "./Closed";
import InProgress from "./InProgress";
import Open from "./Open";

const ReqMain = ({ value }) => {
  return (
    <div>
      {value === 2 && <Open />}
      {value === 3 && <InProgress />}
      {value === 4 && <Closed />}
      {value === 1 && <All />}
    </div>
  );
};

export default ReqMain;
